<template>
  <SpotlightGroupItem :item="item" @on-item-click="onItemClick">
    <template #preview>
      <img v-if="item.hasThumbnailPreview" :src="item.thumbnailSource" width="30" class="m-r-2" />
      <i v-else :class="[getFileTypeIcon(item)]" class="icon is-size-2 cls has-text-primary" />
    </template>
    <template #subtitle>
      <span class="has-text-ellipsis">{{ item.estate.fullName }}</span>
      <span class="is-inline-block m-l-3 m-r-3">•</span>
      <UserAvatar
        v-if="item.uploadedByUser"
        class="is-relative xy-t--3"
        size="20"
        :user="item.uploadedByUser"
      />
      <TooltipView type="is-dark" :label="$t('document.uploaded-by')" :delay="250">
        <div class="m-l-2" :data-e2e="SpotlightCypressAttribute.views.DOCUMENT_UPLOADED_BY_USER">
          {{ getUploadedByName(item) }}
        </div>
      </TooltipView>
    </template>
  </SpotlightGroupItem>
</template>

<script>
import { Document } from '@/modules/document/models/Document';
import SpotlightGroupItem from '@/modules/spotlight/components/presentational/SpotlightGroupItem.vue';
import UserAvatar from '@/modules/user/components/presentational/UserAvatar.vue';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';
import { SpotlightCypressAttribute } from '@/modules/spotlight/constants/SpotlightCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightDocumentGroupItem',
  emits: ['on-item-click'],
  components: { SpotlightGroupItem, UserAvatar, TooltipView },
  props: {
    item: Document
  },
  static: {
    SpotlightCypressAttribute
  },
  computed: {
    getDefaultFileIcon() {
      return 'cls cls-picture-polaroid-landscape-1';
    }
  },
  methods: {
    onItemClick() {
      this.$emit('on-item-click', this.item);
    },
    getFileTypeIcon(document) {
      return document.fileTypeIcon || this.getDefaultFileIcon;
    },
    getUploadedByName(document) {
      return document.uploadedByUser?.contact?.fullName ?? this.$t('core.unknown-user');
    }
  }
};
</script>
